import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/newIndex'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title:'首页'
    }
  },
  {
    path: '/phone',
    name: 'phone',
    component: () => import('../views/phone/index.vue'),
    meta: {
      title:'手机首页'
    }
  },
  {
    path: '/brandConceptPhone',
    name: 'brandConceptPhone',
    component: () => import('../views/phone/brandConceptPhone.vue'),
    meta: {
      title:'品牌理念'
    }
  },
  {
    path: '/brandConcept',
    name: 'brandConcept',
    component: () => import('../views/brandConcept.vue'),
    meta: {
      title:'品牌理念'
    }
  },
  {
    path: '/intelligentGuidanceIndex',
    name: 'intelligentGuidance',
    component: () => import('../views/intelligentGuidance.vue'),
    meta: {
      title: '智慧导诊'
    }
  },
  {
    path: '/intelligentGuidanceIndexPhone',
    name: 'intelligentGuidancePhone',
    component: () => import('../views/phone/intelligentGuidancePhone.vue'),
    meta: {
      title: '智慧导诊'
    }
  },
  {
    path: '/enterpriseInformation',
    name: 'enterpriseInformation',
    component: () => import('../views/enterpriseInformation.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/enterpriseInformationPhone',
    name: 'enterpriseInformationPhone',
    component: () => import('../views/phone/enterpriseInformationPhone.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/enterpriseInformationInfo',
    name: 'enterpriseInformationInfo',
    component: () => import('../views/enterpriseInformationInfo.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/enterpriseInformationInfoPhone',
    name: 'enterpriseInformationInfoPhone',
    component: () => import('../views/phone/enterpriseInformationInfoPhone.vue'),
    meta: {
      title:'企业资讯'
    }
  },
  {
    path: '/businessCooperation',
    name: 'businessCooperation',
    component: () => import('../views/businessCooperation.vue'),
    meta: {
      title:'商务合作'
    }
  },
  {
    path: '/businessCooperationPhone',
    name: 'businessCooperationPhone',
    component: () => import('../views/phone/businessCooperationPhone.vue'),
    meta: {
      title:'商务合作'
    }
  },
  {
    path: '/coreProduct',
    name: 'coreProduct',
    component: () => import('../views/coreProduct.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/coreProductPhone',
    name: 'coreProductPhone',
    component: () => import('../views/phone/coreProductPhone.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/coreProductInfo',
    name: 'coreProductInfo',
    component: () => import('../views/coreProductInfo.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/coreProductInfoPhone',
    name: 'coreProductInfoPhone',
    component: () => import('../views/phone/coreProductInfoPhone.vue'),
    meta: {
      title:'核心产品'
    }
  },
  {
    path: '/talentRecruitment',
    name: 'talentRecruitment',
    component: () => import('../views/talentRecruitment.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/talentRecruitmentPhone',
    name: 'talentRecruitmentPhone',
    component: () => import('../views/phone/talentRecruitmentPhone.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/recruitInfoPhone',
    name: 'recruitInfoPhone',
    component: () => import('../views/phone/recruitInfoPhone.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/recruitInfo',
    name: 'recruitInfo',
    component: () => import('../views/recruitInfo.vue'),
    meta: {
      title:'人才招聘'
    }
  },
  {
    path: '/contactUsPhone',
    name: 'contactUsPhone',
    component: () => import('../views/phone/contactUsPhone.vue'),
    meta: {
      title:'联系我们'
    }
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/contactUs.vue'),
    meta: {
      title:'联系我们'
    }
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
